import _ from "lodash";
import { useTranslation } from "react-i18next";
import UserSettingsService from "src/services/userSettingsService";

import { useDeviceRegistrationGroup } from "@dashboard/shared/hooks/useDeviceRegistrationGroup";
import { useCurrentSubscriptionExpired, useIsWorkspaceFeatureLimitReached } from "@dashboard/workspaces/api/helpers";

export const useCreateProvisioningGate = () => {
    const { t } = useTranslation(["pages"]);
    const isOverLimit = useIsWorkspaceFeatureLimitReached("ProvisioningLimit");
    const isExpired = useCurrentSubscriptionExpired();

    const getReason = () => {
        if (isOverLimit) {
            return t("pages:provisioningPage.tooltip.provisioningLimitReached");
        }
        if (isExpired) {
            return t("pages:provisioningPage.tooltip.subscriptionExpired");
        }
        return "";
    };

    return { disabled: isOverLimit || isExpired, reason: getReason() };
};

export const useUniversalLicenses = () => {
    const { getUniversalLicensesForGroup, createUniversalLicense } = useDeviceRegistrationGroup();

    return async (registrationGroupId: number | undefined, universalLicenses: string[] = []) => {
        if (!registrationGroupId) {
            return universalLicenses;
        }

        const groupUniversalLicenses = getUniversalLicensesForGroup(registrationGroupId).filter(
            (license) => license.universalGroupName,
        );

        if (!groupUniversalLicenses.length) {
            const newLicenseCode = await createUniversalLicense(registrationGroupId);
            if (newLicenseCode) {
                return _.uniq([...universalLicenses, newLicenseCode]);
            }
        } else {
            const codes = groupUniversalLicenses.map((i) => i.activationCode);
            return _.uniq([...universalLicenses, ...codes]);
        }

        return universalLicenses;
    };
};
export const getAllSectionExpandedState = () => {
    const collapsedSections = UserSettingsService.getProvisioningPageCollapsedSections();
    const collapsedSectionsValues = Object.values(collapsedSections || {});

    if (collapsedSectionsValues.every((item) => item)) {
        return true;
    }
    if (collapsedSectionsValues.every((item) => !item)) {
        return false;
    }
    return null;
};
